import { render } from "./VehicleRequest.vue?vue&type=template&id=6fa8913e&scoped=true"
import script from "./VehicleRequest.vue?vue&type=script&lang=js"
export * from "./VehicleRequest.vue?vue&type=script&lang=js"

import "./VehicleRequest.vue?vue&type=style&index=0&id=6fa8913e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa8913e"]])

export default __exports__